// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;900&family=Noto+Sans:wght@400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght@100..700,0..1&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.course-details-page {
  --course-type-heading: clamp(2.1rem, 2.4vw, 2.5rem);
  --course-type-card-heading: 1.25rem;
  --course-type-body: 1.0625rem;
  --course-type-body-lg: 1.125rem;
  --course-type-cta: 1rem;
  background: #ece4ed;
  min-height: 100vh;
  color: #0d121b;
  font-family: 'Noto Sans', 'Inter', sans-serif;
  padding: 6rem 1rem 4rem;
}

.course-details-wrapper {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.course-tab-selector {
  display: flex;
  gap: 0.75rem;
  border-radius: 15px;
  background: #d6c3d9;
  padding: 0.3rem;
  box-shadow: 0 10px 10px rgba(15, 23, 42, 0.08);
  border: 2px solid #400C4D;
}

.course-tab {
  flex: 1;
  border: none;
  background: transparent;
  padding: 0.3rem 1rem;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  border-radius: 999px;
  color: #400C4D;
  transition: all 0.4s ease;
}

.course-tab--active {
  background: linear-gradient(135deg, #400C4D, #4a1548);
  color: white;
  box-shadow: 0 10px 30px rgba(64, 12, 77, 0.35);
}

.course-tab--link {
  background: #d6c3d9;
  color: #400C4D;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.1);
}

/* ==============================
   HERO (JEE / NEET)
   ============================== */

.course-hero-card {
  position: relative;
  display: flex;
  align-items: stretch;
  gap: 1rem;
  padding: 0rem;
  border-radius: 22px;
  background: linear-gradient(135deg, #400C4D, #2a082d);
  box-shadow: 0 26px 60px rgba(64, 12, 77, 0.25);
}

.hero-media {
  background-color: transparent;
  position: relative;
  flex: 0 0 48%;
  min-height: 360px;
  border-radius: 22px;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  box-shadow: 0 18px 44px rgba(13, 18, 27, 0.18);
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0));
  pointer-events: none;
  opacity: 0.35;
}

.hero-content {
  flex: 1;
  padding: 8px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.9rem;
  color: #ffffff;
}

.hero-badge {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #400C4D;
  background: rgba(255, 255, 255, 0.92);
}

.course-hero-card h1 {
  margin: 0;
  font-family: 'Lexend', 'Noto Sans', sans-serif;
  font-weight: 900;
  letter-spacing: -0.02em;
  font-size: clamp(34px, 3.6vw, 56px);
  line-height: 1.05;
  color: #ffffff;
}

.course-hero-card p {
  margin: 0;
  max-width: 520px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  font-size: 14.5px;
}

.course-hero-card .neet-samarpan-text {
  margin-top: 0.5rem;
  max-width: 720px;
  color: #f59e0b !important;
  font-size: 1.18rem;
  line-height: 1.5;
  font-weight: 600;
}

.course-hero-card .jee-sunischit-text {
  margin-top: 0.5rem;
  max-width: 720px;
  color: #f59e0b !important;
  font-size: 1.18rem;
  line-height: 1.5;
  font-weight: 600;
}

.course-hero-card .hero-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: 0.75rem;
  width: auto;
}

.course-hero-card .hero-cta {
  border: none;
  cursor: pointer;
  font-weight: 800;
  border-radius: 12px;
  padding: 12px 18px;
  font-size: 14px;
  line-height: 1.2;
  white-space: nowrap;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, filter 0.15s ease;
  box-shadow: none;
}

.course-hero-card .hero-cta:hover {
  transform: translateY(-1px);
  color: #f59e0b;
  filter: brightness(0.98);
}

.course-hero-card .hero-cta--primary {
  background: white;
  color: #400C4D;
  box-shadow: 0 16px 34px rgba(64, 12, 77, 0.26);
  border: 3px solid #400C4D;
}

.course-hero-card .hero-cta--primary:hover,
.course-hero-card .hero-cta--primary:focus,
.course-hero-card .hero-cta--primary:active {
  background: #ffffff;
  color: #f59e0b;
}

.course-hero-card .hero-cta--secondary {
  background: transparent;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.course-hero-card .hero-cta--secondary:hover,
.course-hero-card .hero-cta--secondary:focus,
.course-hero-card .hero-cta--secondary:active {
  background: transparent;
  color: #f59e0b;
}

/* JEE: image LEFT, content RIGHT */
.course-hero-card--jee {
  flex-direction: row-reverse;
}

.course-hero-card--jee .hero-media {
  background-position: left center;
  background-size: 75%;
}

.course-hero-card--jee .hero-media {
  /* background-size: 85%;
  width: 40%; */
  background-position: left center;
}

/* NEET: content LEFT, image RIGHT */
.course-hero-card--neet {
  flex-direction: row;
}

.course-hero-card--neet .hero-media {
  background-position: right center;
  background-size: 75%;

}

.course-hero-card--neet .hero-media {
  background-position: right center;
}

@media (max-width: 980px) {
  .course-hero-card {
    flex-direction: column;
    padding: 1rem;
  }

  .hero-media {
    flex: none;
    width: 100%;
    min-height: 300px;
    border-radius: 20px;
  }

  .hero-content {
    padding: 1.25rem 1rem 1.4rem;
    text-align: left;
  }

  .course-hero-card .hero-actions {
    flex-direction: column;
    align-items: flex-start;
  }
}

.course-highlights,
.course-curriculum,
.course-advantage {
  background: white;
  border-radius: 1.5rem;
  padding: 2.25rem;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
}

.course-highlights h2,
.course-curriculum h2,
.course-advantage h2 {
  margin: 0 0 1rem;
  font-size: var(--course-type-heading);
  color: #400C4D;
}

.highlight-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.25rem;

}

.highlight-card {
  border: 2px solid #400C4D;
  border-radius: 1.25rem;
  padding: 1.25rem;
  display: flex;
  gap: 0.9rem;
  align-items: flex-start;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  background-color: #d6c3d9;
}

.highlight-card:hover {
  border-color: #A758AB;
  box-shadow: 0 15px 30px rgba(15, 23, 42, 0.12);
}

.highlight-icon {
  width: 60px;
  height: 60px;
  border-radius: 999px;
  background: transparent;
  color: #400C4D;
  display: grid;
  place-items: center;
  font-size: 1.5rem;
}

.highlight-card h3 {
  margin: 0;
  font-size: var(--course-type-card-heading);
  font-weight: 600;
}

.highlight-card p {
  margin: 0.35rem 0 0;
  color: #400C4D;
  font-size: var(--course-type-body-lg);
  line-height: 1.55;
}

.section-heading {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  flex-wrap: wrap;
}

.brochure-link {
  font-weight: 600;
  color: #400C4D;
  cursor: pointer;
}

.brochure-links {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
}

.subtext {
  margin: 0 0 1rem;
  color: #4c669a;
}

.curriculum-panels {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.curriculum-panel {
  border: 2px solid #400C4D;
  border-radius: 0.85rem;
  padding: 0;
  background: #d6c3d9;
  overflow: hidden;
}

.curriculum-panel summary {
  cursor: pointer;
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  color: #0d121b;
  gap: 0.75rem;
}

.curriculum-panel summary span {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.curriculum-panel .expand-indicator {
  transition: transform 0.45s ease;
}

.curriculum-panel .expand-indicator.is-open {
  transform: rotate(180deg);
}

.panel-body {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  padding: 0 1.5rem;
  color: #3f3434;
  font-size: var(--course-type-body);
  line-height: 1.5;
  font-weight: 500;
  transition: max-height 0.5s ease, opacity 0.4s ease, padding 0.5s ease;
}

.curriculum-panel[open] .panel-body {
  max-height: 460px;
  opacity: 1;
  padding: 0 1.5rem 1.25rem;
}

.panel-body ul {
  margin: 0.75rem 0 0;
  padding-left: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  color: #400C4D;
}

.highlight-note {
  margin-top: 1.5rem;
  border-radius: 1rem;
  background: #F6EEF8;
  border: 1px solid #F6EEF8;
  padding: 1rem 1.4rem;
  display: flex;
  gap: 0.65rem;
  align-items: center;
  color: #400C4D;
}

.highlight-note span {
  font-size: 1.4rem;
}

.advantage-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.25rem;
}

.advantage-card {
  border: 2px solid #400C4D;
  border-radius: 1rem;
  padding: 1.25rem;
  background: #d6c3d9;
  display: flex;
  gap: 0.9rem;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.05);
}

.advantage-icon {
  width: 48px;
  height: 48px;
  border-radius: 1rem;
  background: transparent;
  color: #400C4D;
  display: grid;
  place-items: center;
  font-size: 1.6rem;
}

.advantage-card h3 {
  margin: 0;
  font-size: var(--course-type-card-heading);
}

.advantage-card p {
  margin: 0.35rem 0 0;
  color: #400C4D;
  font-size: var(--course-type-body);
  line-height: 1.55;
}

.course-cta {
  background: #400C4D;
  border-radius: 1.75rem;
  padding: clamp(1.75rem, 2.5vw, 2.5rem);
  color: white;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  box-shadow: 0 25px 45px rgba(15, 23, 42, 0.4);
}

.course-cta h2 {
  margin: 0;
  font-size: clamp(1.8rem, 3vw, 2.4rem);
  color :white;
}

.course-cta p {
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
  max-width: 420px;
  font-size: 1.2rem;
}

.cta-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.course-cta .hero-cta,
.course-cta .hero-cta--primary,
.course-cta .hero-cta--secondary {
  background: #400C4D;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.32);
  font-size: var(--course-type-cta);
  box-shadow: none;
}

.course-cta .hero-cta:hover,
.course-cta .hero-cta--primary:hover,
.course-cta .hero-cta--secondary:hover {
  background: #4a1548;
  color: #f59e0b;
}

@media (max-width: 768px) {
  .course-tab-selector {
    flex-direction: column;
  }

  .course-tab {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .hero-content {
    padding: 1.75rem;
  }

  .course-highlights,
  .course-curriculum,
  .course-advantage {
    padding: 1.75rem;
    
  }

  .course-cta {
    flex-direction: column;
    text-align: center;
  }
}

html[data-theme="dark"] .course-details-page {
  background: #030712;
  color: #f8fafc;
}

html[data-theme="dark"] .course-highlights,
html[data-theme="dark"] .course-curriculum,
html[data-theme="dark"] .course-advantage,
html[data-theme="dark"] .course-cta {
  background: #0a0f1c;
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.45);
}

html[data-theme="dark"] .highlight-card,
html[data-theme="dark"] .advantage-card,
html[data-theme="dark"] .curriculum-panel {
  border-color: rgba(255, 255, 255, 0.06);
  background: #111827;
}

html[data-theme="dark"] .highlight-card p,
html[data-theme="dark"] .highlight-card h3,
html[data-theme="dark"] .advantage-card p,
html[data-theme="dark"] .advantage-card h3,
html[data-theme="dark"] .curriculum-panel summary,
html[data-theme="dark"] .curriculum-panel .panel-body,
html[data-theme="dark"] .course-cta p {
  color: #e5e7eb;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Courses/course-details.css"],"names":[],"mappings":"AAGA;EACE,mDAAmD;EACnD,mCAAmC;EACnC,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;;mCAEmC;;AAEnC;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,4EAA4E;EAC5E,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,8CAA8C;EAC9C,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;;;EAGE,uBAAuB;EACvB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE;eACa;EACb,gCAAgC;AAClC;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;;AAEtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;;;EAGE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;;;EAGE,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;;AAEd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,wDAAwD;EACxD,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,sEAAsE;AACxE;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,gBAAgB;;EAElB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,mBAAmB;EACnB,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;;;EAGE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,cAAc;AAChB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;900&family=Noto+Sans:wght@400;500;600&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght@100..700,0..1&display=swap');\n\n.course-details-page {\n  --course-type-heading: clamp(2.1rem, 2.4vw, 2.5rem);\n  --course-type-card-heading: 1.25rem;\n  --course-type-body: 1.0625rem;\n  --course-type-body-lg: 1.125rem;\n  --course-type-cta: 1rem;\n  background: #ece4ed;\n  min-height: 100vh;\n  color: #0d121b;\n  font-family: 'Noto Sans', 'Inter', sans-serif;\n  padding: 6rem 1rem 4rem;\n}\n\n.course-details-wrapper {\n  max-width: 1280px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n}\n\n.course-tab-selector {\n  display: flex;\n  gap: 0.75rem;\n  border-radius: 15px;\n  background: #d6c3d9;\n  padding: 0.3rem;\n  box-shadow: 0 10px 10px rgba(15, 23, 42, 0.08);\n  border: 2px solid #400C4D;\n}\n\n.course-tab {\n  flex: 1;\n  border: none;\n  background: transparent;\n  padding: 0.3rem 1rem;\n  font-weight: 600;\n  font-size: 1.1rem;\n  cursor: pointer;\n  border-radius: 999px;\n  color: #400C4D;\n  transition: all 0.4s ease;\n}\n\n.course-tab--active {\n  background: linear-gradient(135deg, #400C4D, #4a1548);\n  color: white;\n  box-shadow: 0 10px 30px rgba(64, 12, 77, 0.35);\n}\n\n.course-tab--link {\n  background: #d6c3d9;\n  color: #400C4D;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.1);\n}\n\n/* ==============================\n   HERO (JEE / NEET)\n   ============================== */\n\n.course-hero-card {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  gap: 1rem;\n  padding: 0rem;\n  border-radius: 22px;\n  background: linear-gradient(135deg, #400C4D, #2a082d);\n  box-shadow: 0 26px 60px rgba(64, 12, 77, 0.25);\n}\n\n.hero-media {\n  background-color: transparent;\n  position: relative;\n  flex: 0 0 48%;\n  min-height: 360px;\n  border-radius: 22px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  overflow: hidden;\n  box-shadow: 0 18px 44px rgba(13, 18, 27, 0.18);\n}\n\n.hero-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to right, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0));\n  pointer-events: none;\n  opacity: 0.35;\n}\n\n.hero-content {\n  flex: 1;\n  padding: 8px 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.9rem;\n  color: #ffffff;\n}\n\n.hero-badge {\n  width: fit-content;\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 0.9rem;\n  font-weight: 800;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: #400C4D;\n  background: rgba(255, 255, 255, 0.92);\n}\n\n.course-hero-card h1 {\n  margin: 0;\n  font-family: 'Lexend', 'Noto Sans', sans-serif;\n  font-weight: 900;\n  letter-spacing: -0.02em;\n  font-size: clamp(34px, 3.6vw, 56px);\n  line-height: 1.05;\n  color: #ffffff;\n}\n\n.course-hero-card p {\n  margin: 0;\n  max-width: 520px;\n  color: rgba(255, 255, 255, 0.9);\n  line-height: 1.6;\n  font-size: 14.5px;\n}\n\n.course-hero-card .neet-samarpan-text {\n  margin-top: 0.5rem;\n  max-width: 720px;\n  color: #f59e0b !important;\n  font-size: 1.18rem;\n  line-height: 1.5;\n  font-weight: 600;\n}\n\n.course-hero-card .jee-sunischit-text {\n  margin-top: 0.5rem;\n  max-width: 720px;\n  color: #f59e0b !important;\n  font-size: 1.18rem;\n  line-height: 1.5;\n  font-weight: 600;\n}\n\n.course-hero-card .hero-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-top: 0.75rem;\n  width: auto;\n}\n\n.course-hero-card .hero-cta {\n  border: none;\n  cursor: pointer;\n  font-weight: 800;\n  border-radius: 12px;\n  padding: 12px 18px;\n  font-size: 14px;\n  line-height: 1.2;\n  white-space: nowrap;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.15s ease, filter 0.15s ease;\n  box-shadow: none;\n}\n\n.course-hero-card .hero-cta:hover {\n  transform: translateY(-1px);\n  color: #f59e0b;\n  filter: brightness(0.98);\n}\n\n.course-hero-card .hero-cta--primary {\n  background: white;\n  color: #400C4D;\n  box-shadow: 0 16px 34px rgba(64, 12, 77, 0.26);\n  border: 3px solid #400C4D;\n}\n\n.course-hero-card .hero-cta--primary:hover,\n.course-hero-card .hero-cta--primary:focus,\n.course-hero-card .hero-cta--primary:active {\n  background: #ffffff;\n  color: #f59e0b;\n}\n\n.course-hero-card .hero-cta--secondary {\n  background: transparent;\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.course-hero-card .hero-cta--secondary:hover,\n.course-hero-card .hero-cta--secondary:focus,\n.course-hero-card .hero-cta--secondary:active {\n  background: transparent;\n  color: #f59e0b;\n}\n\n/* JEE: image LEFT, content RIGHT */\n.course-hero-card--jee {\n  flex-direction: row-reverse;\n}\n\n.course-hero-card--jee .hero-media {\n  background-position: left center;\n  background-size: 75%;\n}\n\n.course-hero-card--jee .hero-media {\n  /* background-size: 85%;\n  width: 40%; */\n  background-position: left center;\n}\n\n/* NEET: content LEFT, image RIGHT */\n.course-hero-card--neet {\n  flex-direction: row;\n}\n\n.course-hero-card--neet .hero-media {\n  background-position: right center;\n  background-size: 75%;\n\n}\n\n.course-hero-card--neet .hero-media {\n  background-position: right center;\n}\n\n@media (max-width: 980px) {\n  .course-hero-card {\n    flex-direction: column;\n    padding: 1rem;\n  }\n\n  .hero-media {\n    flex: none;\n    width: 100%;\n    min-height: 300px;\n    border-radius: 20px;\n  }\n\n  .hero-content {\n    padding: 1.25rem 1rem 1.4rem;\n    text-align: left;\n  }\n\n  .course-hero-card .hero-actions {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n.course-highlights,\n.course-curriculum,\n.course-advantage {\n  background: white;\n  border-radius: 1.5rem;\n  padding: 2.25rem;\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);\n}\n\n.course-highlights h2,\n.course-curriculum h2,\n.course-advantage h2 {\n  margin: 0 0 1rem;\n  font-size: var(--course-type-heading);\n  color: #400C4D;\n}\n\n.highlight-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.25rem;\n\n}\n\n.highlight-card {\n  border: 2px solid #400C4D;\n  border-radius: 1.25rem;\n  padding: 1.25rem;\n  display: flex;\n  gap: 0.9rem;\n  align-items: flex-start;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  background-color: #d6c3d9;\n}\n\n.highlight-card:hover {\n  border-color: #A758AB;\n  box-shadow: 0 15px 30px rgba(15, 23, 42, 0.12);\n}\n\n.highlight-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 999px;\n  background: transparent;\n  color: #400C4D;\n  display: grid;\n  place-items: center;\n  font-size: 1.5rem;\n}\n\n.highlight-card h3 {\n  margin: 0;\n  font-size: var(--course-type-card-heading);\n  font-weight: 600;\n}\n\n.highlight-card p {\n  margin: 0.35rem 0 0;\n  color: #400C4D;\n  font-size: var(--course-type-body-lg);\n  line-height: 1.55;\n}\n\n.section-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.brochure-link {\n  font-weight: 600;\n  color: #400C4D;\n  cursor: pointer;\n}\n\n.brochure-links {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.25rem;\n}\n\n.subtext {\n  margin: 0 0 1rem;\n  color: #4c669a;\n}\n\n.curriculum-panels {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.curriculum-panel {\n  border: 2px solid #400C4D;\n  border-radius: 0.85rem;\n  padding: 0;\n  background: #d6c3d9;\n  overflow: hidden;\n}\n\n.curriculum-panel summary {\n  cursor: pointer;\n  padding: 1.25rem 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 600;\n  color: #0d121b;\n  gap: 0.75rem;\n}\n\n.curriculum-panel summary span {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.curriculum-panel .expand-indicator {\n  transition: transform 0.45s ease;\n}\n\n.curriculum-panel .expand-indicator.is-open {\n  transform: rotate(180deg);\n}\n\n.panel-body {\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n  padding: 0 1.5rem;\n  color: #3f3434;\n  font-size: var(--course-type-body);\n  line-height: 1.5;\n  font-weight: 500;\n  transition: max-height 0.5s ease, opacity 0.4s ease, padding 0.5s ease;\n}\n\n.curriculum-panel[open] .panel-body {\n  max-height: 460px;\n  opacity: 1;\n  padding: 0 1.5rem 1.25rem;\n}\n\n.panel-body ul {\n  margin: 0.75rem 0 0;\n  padding-left: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  color: #400C4D;\n}\n\n.highlight-note {\n  margin-top: 1.5rem;\n  border-radius: 1rem;\n  background: #F6EEF8;\n  border: 1px solid #F6EEF8;\n  padding: 1rem 1.4rem;\n  display: flex;\n  gap: 0.65rem;\n  align-items: center;\n  color: #400C4D;\n}\n\n.highlight-note span {\n  font-size: 1.4rem;\n}\n\n.advantage-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.25rem;\n}\n\n.advantage-card {\n  border: 2px solid #400C4D;\n  border-radius: 1rem;\n  padding: 1.25rem;\n  background: #d6c3d9;\n  display: flex;\n  gap: 0.9rem;\n  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.05);\n}\n\n.advantage-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 1rem;\n  background: transparent;\n  color: #400C4D;\n  display: grid;\n  place-items: center;\n  font-size: 1.6rem;\n}\n\n.advantage-card h3 {\n  margin: 0;\n  font-size: var(--course-type-card-heading);\n}\n\n.advantage-card p {\n  margin: 0.35rem 0 0;\n  color: #400C4D;\n  font-size: var(--course-type-body);\n  line-height: 1.55;\n}\n\n.course-cta {\n  background: #400C4D;\n  border-radius: 1.75rem;\n  padding: clamp(1.75rem, 2.5vw, 2.5rem);\n  color: white;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  box-shadow: 0 25px 45px rgba(15, 23, 42, 0.4);\n}\n\n.course-cta h2 {\n  margin: 0;\n  font-size: clamp(1.8rem, 3vw, 2.4rem);\n  color :white;\n}\n\n.course-cta p {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.85);\n  max-width: 420px;\n  font-size: 1.2rem;\n}\n\n.cta-actions {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.course-cta .hero-cta,\n.course-cta .hero-cta--primary,\n.course-cta .hero-cta--secondary {\n  background: #400C4D;\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.32);\n  font-size: var(--course-type-cta);\n  box-shadow: none;\n}\n\n.course-cta .hero-cta:hover,\n.course-cta .hero-cta--primary:hover,\n.course-cta .hero-cta--secondary:hover {\n  background: #4a1548;\n  color: #f59e0b;\n}\n\n@media (max-width: 768px) {\n  .course-tab-selector {\n    flex-direction: column;\n  }\n\n  .course-tab {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n  }\n\n  .hero-content {\n    padding: 1.75rem;\n  }\n\n  .course-highlights,\n  .course-curriculum,\n  .course-advantage {\n    padding: 1.75rem;\n    \n  }\n\n  .course-cta {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n\nhtml[data-theme=\"dark\"] .course-details-page {\n  background: #030712;\n  color: #f8fafc;\n}\n\nhtml[data-theme=\"dark\"] .course-highlights,\nhtml[data-theme=\"dark\"] .course-curriculum,\nhtml[data-theme=\"dark\"] .course-advantage,\nhtml[data-theme=\"dark\"] .course-cta {\n  background: #0a0f1c;\n  border-color: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.45);\n}\n\nhtml[data-theme=\"dark\"] .highlight-card,\nhtml[data-theme=\"dark\"] .advantage-card,\nhtml[data-theme=\"dark\"] .curriculum-panel {\n  border-color: rgba(255, 255, 255, 0.06);\n  background: #111827;\n}\n\nhtml[data-theme=\"dark\"] .highlight-card p,\nhtml[data-theme=\"dark\"] .highlight-card h3,\nhtml[data-theme=\"dark\"] .advantage-card p,\nhtml[data-theme=\"dark\"] .advantage-card h3,\nhtml[data-theme=\"dark\"] .curriculum-panel summary,\nhtml[data-theme=\"dark\"] .curriculum-panel .panel-body,\nhtml[data-theme=\"dark\"] .course-cta p {\n  color: #e5e7eb;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
